export const CANDIDATE = {
  stepIndicator: (n) => `apply-step-indicator-${n}`,
  nextBtn: "apply-next-btn",
  backBtn: "apply-back-btn",
  submitBtn: "apply-submit-btn",

  // Personal
  fullName: "apply-full-name",
  email: "apply-email",
  phone: "apply-phone",
  dob: "apply-dob",
  nationality: "apply-nationality",
  address1: "apply-address1",
  city: "apply-city",
  country: "apply-country",
  emergencyName: "apply-emergency-name",
  emergencyRelation: "apply-emergency-relation",
  emergencyPhone: "apply-emergency-phone",

  // Professional
  yearsExp: "apply-years-exp",
  ftthYears: "apply-ftth-years",
  skillInput: "apply-skill-input",
  addSkill: "apply-add-skill-btn",
  skillTag: (i) => `apply-skill-tag-${i}`,
  certName: "apply-cert-name",
  certIssuer: "apply-cert-issuer",
  certYear: "apply-cert-year",
  addCert: "apply-add-cert-btn",
  previousEmployer: "apply-prev-employer",
  previousRole: "apply-prev-role",
  driverLicense: "apply-driver-license",
  hasTools: "apply-has-tools",

  // Vehicle & Insurance
  truckPicture: "apply-truck-picture",
  insuranceCertificate: "apply-insurance-cert",
  vehicleReadiness: "apply-vehicle-readiness",

  // Client intake context (visual)
  clientBanner: "apply-client-banner",

  // Assignment (project + role)
  project: "apply-project",
  role: "apply-role",

  // Bank
  bankName: "apply-bank-name",
  bankHolder: "apply-bank-holder",
  bankAccount: "apply-bank-account",
  bankRouting: "apply-bank-routing",
  bankIban: "apply-bank-iban",
  bankSwift: "apply-bank-swift",
  taxId: "apply-tax-id",

  // Immigration
  immStatus: "apply-imm-status",
  immExpiry: "apply-imm-expiry",
  immNotes: "apply-imm-notes",
  docKind: "apply-doc-kind",
  docLabel: "apply-doc-label",
  docExpiry: "apply-doc-expiry",
  docFile: "apply-doc-file",
  addDoc: "apply-add-doc-btn",
  docItem: (i) => `apply-doc-item-${i}`,
  removeDoc: (i) => `apply-doc-remove-${i}`,

  // Success
  successRef: "apply-success-reference",
  successHome: "apply-success-home-btn",
};
